<template>
	<el-menu
      :unique-opened="true"
      :default-active="this.$store.state.menus.editableTabsValue"
			class="el-menu-vertical-demo"
			background-color="#545c64"
			text-color="#fff"
			active-text-color="#ffd04b">
		<router-link to="/index">
			<el-menu-item index="Index" @click="selectMenu({name: 'Index', title: '首页'})">
				<template slot="title">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</template>
			</el-menu-item>
		</router-link>

    <!-- 递归动态菜单 -->
    <!--<myitem :data="menuList"></myitem>-->

		<el-submenu :index="menu.name" v-for="menu in menuList">
			<template slot="title">
				<i :class="menu.icon"></i>
				<span>{{menu.title}}</span>
			</template>

			<router-link :to="item.path" v-for="item in menu.children">
				<el-menu-item :index="item.name" @click="selectMenu(item)">
					<template slot="title">
						<i :class="item.icon"></i>
						<span slot="title">{{item.title}}</span>
					</template>
				</el-menu-item>
			</router-link>
		</el-submenu>

	</el-menu>
</template>

<script>
  import myitem from "./subMenu"; // 引入递归菜单组件
	export default {
		name: "SideMenu",
		data() {
			return {

			}
		},
    components: {
      myitem, // 注册一下
    },
    computed:  {
      menuList() {
        const list = this.$store.state.menus.menuList || []
        return list.map(group => ({
          ...group,
          children: (group.children || []).filter(item => item && item.path && item.title)
        }))
      }
    },
		methods: {
			selectMenu(item) {
				this.$store.commit("addTab", item)
			}
		}
	}
</script>

<style scoped>
	.el-menu-vertical-demo {
		height: 100%;
	}
	.el-menu > a {
		text-decoration: none;
	}
</style>
